import { withFormsy, propTypes } from "formsy-react";
import React from "react";
import ErrorLabel from "../../../common/errorLabel";
import Util from "../../../../util/util";
import { DiscoverConstants } from "../../../../configurations/discoverConfigs/discoverConstants";
import Tooltip from "../../../common/tooltip";
class TextInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dollarAmount: null
    };
    this.changeValue = this.changeValue.bind(this);
    this.getDollarAmount = this.getDollarAmount.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.transactionDetails &&
      nextProps.transactionDetails.settlementRate &&
      nextProps.transactionDetails.settlementAmount &&
      nextProps.currency
    ) {
      this.getDollarAmount(nextProps.getValue());
    }
  }

  changeValue(event) {
    if (
      event.target.value === "" ||
      this.props.isValidValue(event.target.value) ||
      this.props.type !== "text"
    ) {
      this.props.setValue(event.target.value);
    }
  }

  getDollarAmount(value) {
    let stringAmount = null;
    if (value) {
      const amount =
        Number(value) / Number(this.props.transactionDetails.settlementRate);
      stringAmount = Util.commanumbers(amount);
    }
    this.setState({ dollarAmount: stringAmount });
  }

  render() {
    const errorMessage = this.props.getErrorMessage();
    const {
      showRequired,
      showError,
      getValue,
      name,
      description,
      label,
      isPristine,
      type,
      className,
      isRequired,
      currency,
      multiline,
      disableFields,
      transactionDetails,
      caption
    } = this.props;

    const { dollarAmount } = this.state;
    const hasError =
      (!isPristine() && showError()) || (getValue() && showError());
    const requiredError = showRequired() && !isPristine();

    return (
      <div className="form-group">
        <label
          className={`input-control-label ${isRequired() ? "required" : ""}`}
          htmlFor={name}
        >
          {label}{" "}
          {description && (
            <Tooltip message={description} position={"bottom"}>
              (?)
            </Tooltip>
          )}
          {caption && (
            <small className="text-info">
              ({caption}
              {transactionDetails && currency && name === "disputeAmount"
                ? `: ${transactionDetails.settlementAmount}`
                : ""}
              )
            </small>
          )}
        </label>
        {multiline ? (
          <textarea
            rows={4}
            value={getValue() || ""}
            onChange={this.changeValue}
            name={name}
            id={name}
            disabled={disableFields}
            className={`form-control ${
              hasError || requiredError ? "error" : ""
            } ${className}`}
            autoComplete="on"
          />
        ) : currency ? (
          <div className="input-group">
            <span className="input-group-addon">
              {transactionDetails &&
                transactionDetails.settlementCurrencyCode &&
                DiscoverConstants.CurrencyCodes[
                  transactionDetails.settlementCurrencyCode
                ]}
            </span>
            <input
              type={type || "text"}
              value={getValue() || ""}
              onChange={this.changeValue}
              name={name}
              id={name}
              disabled={disableFields}
              className={`form-control ${
                hasError || requiredError ? "error" : ""
              } ${className}`}
              autoComplete="on"
            />
            {dollarAmount && dollarAmount !== "0" && (
              <span className="input-group-addon">
                Amount in USD: {dollarAmount}
              </span>
            )}
          </div>
        ) : (
          <input
            type={type || "text"}
            value={getValue() || ""}
            onChange={this.changeValue}
            name={name}
            id={name}
            disabled={disableFields}
            className={`form-control ${
              hasError || requiredError ? "error" : ""
            } ${className}`}
            autoComplete="on"
          />
        )}
        <ErrorLabel message={hasError ? errorMessage : ""} />
        <ErrorLabel message={requiredError ? "Required" : ""} />
      </div>
    );
  }
}

TextInput.propTypes = {
  ...propTypes
};

export default withFormsy(TextInput);



// WEBPACK FOOTER //
// ./src/components/discover/common/controls/TextInput.js